import { render, staticRenderFns } from "./CookiePolicyPage.vue?vue&type=template&id=9e803bc2&scoped=true&"
import script from "./CookiePolicyPage.vue?vue&type=script&lang=js&"
export * from "./CookiePolicyPage.vue?vue&type=script&lang=js&"
import style0 from "./CookiePolicyPage.vue?vue&type=style&index=0&id=9e803bc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e803bc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e803bc2')) {
      api.createRecord('9e803bc2', component.options)
    } else {
      api.reload('9e803bc2', component.options)
    }
    module.hot.accept("./CookiePolicyPage.vue?vue&type=template&id=9e803bc2&scoped=true&", function () {
      api.rerender('9e803bc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CookiePolicyPage.vue"
export default component.exports